import React from 'react'

class Dropdown extends React.Component {

	handleChange = (e) => {
		if (this.props.onSelectChange) {
			const change = {
				property: this.props.property,
				name: this.props.name,
				newValue: e.target.value
			}
			this.props.onSelectChange(change)
		}
	}

	render() {
		const options = this.props.options.map((option) => (
			<option key={option.value} value={option.value}>
				{option.label}
			</option>
		))
		return (
			<div>
				<select
					className='capps-input dropdown'
					disabled={this.props.disabled ? this.props.disabled : false}
					onChange={(e) => this.handleChange(e)}
					name={this.props.name}
					value={this.props.value}
				>
					{options}
				</select>
			</div>
		)
	}

}

export default Dropdown



// WEBPACK FOOTER //
// ./src/Components/Display/Dropdown.js